export default "__VITE_ASSET__Be__2fUo__"